import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomDialog } from "../../../global/components";
import urls from "../../../global/constants/UrlConstants";
import {
  handleErrorMessage,
  openSuccessNotification,
} from "../../../helpers/methods";
import { cancelSubscriptionAction } from "../../../redux/authSlice";
import history from "../../../utils/history";
import { store } from "../../../utils/store";
import subscriptionStyles from "../Subscriptions.styles";
import { cancelSubscription } from "../SubscriptionsService";

interface CustomProps {
  setIsLoading: Function;
  handleClose: Function;
  open: boolean;
  endDate: string | undefined;
}

const CancelSubscriptionDialog = (props: CustomProps) => {
  const classes = subscriptionStyles;
  const { t } = useTranslation();

  const handleCancelSubscription = async () => {
    try {
      props.setIsLoading(true);
      const response = await cancelSubscription();
      openSuccessNotification(response.message);
      store.dispatch(cancelSubscriptionAction());
      history.push(urls.dashboardViewPath);
      props.setIsLoading(false);
    } catch (error: any) {
      props.setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const dialogHeaderContent = () => {
    return (
      <Stack direction={"column"} alignItems={"center"} spacing={2} pt={5}>
        <Typography sx={classes.modalHeader} px={2}>
          {t("cancelPlanHeader")}
        </Typography>

        <Divider
          sx={{
            border: "1px solid #222222",
            width: "50%",
            height: "0px",
          }}
        />
      </Stack>
    );
  };

  const dialogBodyContent = () => {
    return (
      <Stack direction={"column"} pb={5} spacing={2} sx={classes.dialogContent}>
        <Typography sx={classes.lightFont} pt={2}>
          {t("cancelPlanContent1")}
          <br />
          {t("cancelPlanContent2")}
        </Typography>
        <Typography sx={classes.darkFont} py={2}>
          {t("cancelPlanNote")} {props.endDate}
        </Typography>
        <Stack
          direction={{ sm: "row", xs: "column" }}
          spacing={2}
          alignSelf={"center"}
        >
          <Button onClick={() => props.handleClose()} sx={classes.cancelBtn}>
            <Box sx={classes.cancelBtnBox}>
              <Typography className="btnText">{t("no")}</Typography>
            </Box>
          </Button>
          <Button onClick={handleCancelSubscription} sx={classes.logoutBtn}>
            <Typography className="btnText">{t("yes")}</Typography>
          </Button>
        </Stack>
      </Stack>
    );
  };
  const getCancelSubscriptionDialog = () => {
    return (
      <CustomDialog
        width="600px"
        borderRadius="10px"
        isDialogOpen={props.open}
        closable={true}
        closeButtonVisibility={true}
        handleDialogClose={() => props.handleClose()}
        dialogHeaderContent={dialogHeaderContent()}
        dialogBodyContent={dialogBodyContent()}
      />
    );
  };
  return getCancelSubscriptionDialog();
};

export default CancelSubscriptionDialog;
